import * as React from "react"
import styled from "styled-components"
import { Container } from "react-bootstrap"
import gdpr from "../../../images/security_compliance_gdpr.png"
import penetration from "../../../images/penetration_testing.png"
import integrations from "../../../images/integrations_security.png"
import privacy from "../../../images/privacy_and_secuity_feature.png"
import transit from "../../../images/transit_and_atrest.png"
import internal from "../../../images/internal_and_external_audit.png"
import { Link } from "gatsby"

const StyledHeroContainer = styled(Container)`
  .fourth-section-heading {
    text-align: center;
  }
  .card-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 1000px;
    margin: 0 auto;
  }

  .card {
    width: 30%;
    background-color: #fff;
    padding: 20px;
    margin-bottom: 20px;
    text-align: center;
  }

  .card-heading {
    font-size: 24px;
    height: 80px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .card-text {
    font-size: 16px;
  }

  .card img {
    width: 100%;
    height: 125px;
    border-radius: 5px;
  }
  @media only screen and (max-width: 600px) {
    .card {
      width: 100%;
    }
    .card-heading {
      height: auto;
    }
  }
`

const SecurityAndComplianceCard = () => {
  return (
    <StyledHeroContainer>
      <section className="p-3 fourth-section-main">
        <div className="py-2">
          <div className="card-container">
            <div className="card">
              <div className="text-center pb-2">
                <img
                  src={gdpr}
                  alt="gdpr compliant"
                  style={{ width: "110px", height: "110px" }}
                />
              </div>
              <div className="card-heading h3-heading">
                <h3>GDPR Compliant</h3>
              </div>
              <div className="card-text blog-text-area">
                <p>
                  Compliant as both a Data Processor and Data Controller. Learn
                  more about Clearouts GDPR compliance{" "}
                  <Link to="/gdpr">
                    <u>here</u>
                  </Link>
                  .
                </p>
              </div>
            </div>

            <div className="card">
              <div className="text-center pb-2">
                <img
                  src={penetration}
                  alt="penetration testing"
                  style={{ width: "110px", height: "110px" }}
                />
              </div>
              <div className="card-heading h3-heading">
                <h3>Penetration Testing</h3>
              </div>
              <div className="card-text blog-text-area">
                <p>
                  Annual network and graybox application penetration tests are
                  performed by a certified third party consultant.
                </p>
              </div>
            </div>

            <div className="card">
              <div className="text-center pb-2">
                <img
                  src={integrations}
                  alt="integrations security"
                  style={{ width: "110px", height: "110px" }}
                />
              </div>
              <div className="card-heading h3-heading">
                <h3>Integrations Security</h3>
              </div>
              <div className="card-text blog-text-area">
                <p>
                  Offers improved login security through the use of Okta SSO,
                  which simplifies and streamlines access management, audit
                  trails, and compliances.
                </p>
              </div>
            </div>

            <div className="card">
              <div className="text-center pb-2">
                <img
                  src={privacy}
                  alt="privacy and safety features"
                  style={{ width: "110px", height: "110px" }}
                ></img>
              </div>
              <div className="card-heading h3-heading">
                <h3>Privacy & Safety Features</h3>
              </div>
              <div className="card-text blog-text-area">
                <p>
                  Custom control to enable or disable privacy-invading features
                  as needed.
                </p>
              </div>
            </div>

            <div className="card">
              <div className="text-center pb-2">
                <img
                  src={transit}
                  alt="transit and at rest encryption"
                  style={{ width: "110px", height: "110px" }}
                ></img>
              </div>
              <div className="card-heading h3-heading">
                <h3>Transit & At-Rest Encryption</h3>
              </div>
              <div className="card-text blog-text-area">
                <p>
                  SSL level encryption is done over public networks for both
                  idle and active data.
                </p>
              </div>
            </div>

            <div className="card">
              <div className="text-center pb-2">
                <img
                  src={internal}
                  alt="internal and external audits"
                  style={{ width: "110px", height: "110px" }}
                ></img>
              </div>
              <div className="card-heading h3-heading">
                <h3>Internal & External Audits</h3>
              </div>
              <div className="card-text blog-text-area">
                <p>
                  Quarterly audits on access control, risk, IT security &
                  infrastructure.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </StyledHeroContainer>
  )
}

export default SecurityAndComplianceCard
